export default __webpack_public_path__ + "images/bc06ac0f4ec5584147d810c92f23b2cb-minneapolis_desktop.webp";